import { render, staticRenderFns } from "./SecondaryActionButton.vue?vue&type=template&id=03aeb74b&scoped=true&"
import script from "./SecondaryActionButton.vue?vue&type=script&lang=js&"
export * from "./SecondaryActionButton.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryActionButton.vue?vue&type=style&index=0&id=03aeb74b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03aeb74b",
  null
  
)

export default component.exports